import { AppointmentInformationPage } from '@icoach/appointment/';
import { CLUB_APPOINTMENT_ROUTER } from '@icoach/router/routerPath';

const appointmentRouter = [
    {
        description: '預約單明細頁',
        strict: true,
        path: CLUB_APPOINTMENT_ROUTER.INFORMATION_PAGE,
        as: AppointmentInformationPage,
        frontKey: 'C7X02',
    },
];

export default appointmentRouter;
